var _dec,
  _class,
  _Item,
  _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/media_gallery.js",
  _dec2,
  _class2,
  _MediaGallery;
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.take.js";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import { Map as ImmutableMap, is } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getSettings } from 'soapbox/actions/settings';
import Blurhash from 'soapbox/components/blurhash';
import Icon from 'soapbox/components/icon';
import StillImage from 'soapbox/components/still_image';
import { MIMETYPE_ICONS } from 'soapbox/features/compose/components/upload';
import { truncateFilename } from 'soapbox/utils/media';
import { isIOS } from '../is_mobile';
import { isPanoramic, isPortrait, isNonConformingRatio, minimumAspectRatio, maximumAspectRatio } from '../utils/media_aspect_ratio';
import { Button, Text } from './ui';
const ATTACHMENT_LIMIT = 4;
const MAX_FILENAME_LENGTH = 45;
const messages = defineMessages({
  toggle_visible: {
    "id": "media_gallery.toggle_visible",
    "defaultMessage": "Hide"
  }
});
const mapStateToItemProps = state => ({
  autoPlayGif: getSettings(state).get('autoPlayGif')
});
const withinLimits = aspectRatio => {
  return aspectRatio >= minimumAspectRatio && aspectRatio <= maximumAspectRatio;
};
const shouldLetterbox = attachment => {
  const aspectRatio = attachment.getIn(['meta', 'original', 'aspect']);
  if (!aspectRatio) return true;
  return !withinLimits(aspectRatio);
};
let Item = (_dec = connect(mapStateToItemProps), _dec(_class = (_Item = class Item extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      loaded: false
    });
    _defineProperty(this, "handleMouseEnter", e => {
      if (this.hoverToPlay()) {
        e.target.play();
      }
    });
    _defineProperty(this, "handleMouseLeave", e => {
      if (this.hoverToPlay()) {
        e.target.pause();
        e.target.currentTime = 0;
      }
    });
    _defineProperty(this, "handleClick", e => {
      const {
        index,
        onClick
      } = this.props;
      if (isIOS() && !e.target.autoPlay) {
        e.target.autoPlay = true;
        e.preventDefault();
      } else {
        if (e.button === 0 && !(e.ctrlKey || e.metaKey)) {
          if (this.hoverToPlay()) {
            e.target.pause();
            e.target.currentTime = 0;
          }
          e.preventDefault();
          onClick(index);
        }
      }
      e.stopPropagation();
    });
    _defineProperty(this, "handleImageLoad", () => {
      this.setState({
        loaded: true
      });
    });
    _defineProperty(this, "handleVideoHover", ({
      target: video
    }) => {
      video.playbackRate = 3.0;
      video.play();
    });
    _defineProperty(this, "handleVideoLeave", ({
      target: video
    }) => {
      video.pause();
      video.currentTime = 0;
    });
  }
  hoverToPlay() {
    const {
      attachment,
      autoPlayGif
    } = this.props;
    return !autoPlayGif && attachment.get('type') === 'gifv';
  }
  render() {
    const {
      attachment,
      standalone,
      visible,
      dimensions,
      autoPlayGif,
      last,
      total
    } = this.props;
    let width = 100;
    let height = '100%';
    let top = 'auto';
    let left = 'auto';
    let bottom = 'auto';
    let right = 'auto';
    let float = 'left';
    let position = 'relative';
    if (dimensions) {
      width = dimensions.w;
      height = dimensions.h;
      top = dimensions.t || 'auto';
      right = dimensions.r || 'auto';
      bottom = dimensions.b || 'auto';
      left = dimensions.l || 'auto';
      float = dimensions.float || 'left';
      position = dimensions.pos || 'relative';
    }
    let thumbnail = '';
    if (attachment.get('type') === 'unknown') {
      const filename = truncateFilename(attachment.get('remote_url'), MAX_FILENAME_LENGTH);
      const attachmentIcon = /*#__PURE__*/React.createElement(Icon, {
        className: "h-16 w-16 text-gray-800 dark:text-gray-200",
        src: MIMETYPE_ICONS[attachment.getIn(['pleroma', 'mime_type'])] || require('@tabler/icons/paperclip.svg'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 150,
          columnNumber: 9
        }
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('media-gallery__item', {
          standalone
        }),
        key: attachment.get('id'),
        style: {
          position,
          float,
          left,
          top,
          right,
          bottom,
          height,
          width: `${width}%`
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("a", {
        className: "media-gallery__item-thumbnail",
        href: attachment.get('remote_url'),
        target: "_blank",
        style: {
          cursor: 'pointer'
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 158,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement(Blurhash, {
        hash: attachment.get('blurhash'),
        className: "media-gallery__preview",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 159,
          columnNumber: 13
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "media-gallery__item__icons",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 160,
          columnNumber: 13
        }
      }, attachmentIcon), /*#__PURE__*/React.createElement("span", {
        className: "media-gallery__filename__label",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 161,
          columnNumber: 13
        }
      }, filename)));
    } else if (attachment.get('type') === 'image') {
      const originalUrl = attachment.get('url');
      const letterboxed = shouldLetterbox(attachment);
      thumbnail = /*#__PURE__*/React.createElement("a", {
        className: classNames('media-gallery__item-thumbnail', {
          letterboxed
        }),
        href: attachment.get('remote_url') || originalUrl,
        onClick: this.handleClick,
        target: "_blank",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 170,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(StillImage, {
        src: originalUrl,
        alt: attachment.get('description'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 176,
          columnNumber: 11
        }
      }));
    } else if (attachment.get('type') === 'gifv') {
      const conditionalAttributes = {};
      if (isIOS()) {
        conditionalAttributes.playsInline = '1';
      }
      if (autoPlayGif) {
        conditionalAttributes.autoPlay = '1';
      }
      thumbnail = /*#__PURE__*/React.createElement("div", {
        className: classNames('media-gallery__gifv', {
          autoplay: autoPlayGif
        }),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 189,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("video", _extends({
        className: "media-gallery__item-gifv-thumbnail",
        "aria-label": attachment.get('description'),
        title: attachment.get('description'),
        role: "application",
        src: attachment.get('url'),
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        loop: true,
        muted: true
      }, conditionalAttributes, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 190,
          columnNumber: 11
        }
      })), /*#__PURE__*/React.createElement("span", {
        className: "media-gallery__gifv__label",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 204,
          columnNumber: 11
        }
      }, "GIF"));
    } else if (attachment.get('type') === 'audio') {
      const ext = attachment.get('url').split('.').pop().toUpperCase();
      thumbnail = /*#__PURE__*/React.createElement("a", {
        className: classNames('media-gallery__item-thumbnail'),
        href: attachment.get('url'),
        onClick: this.handleClick,
        target: "_blank",
        alt: attachment.get('description'),
        title: attachment.get('description'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 210,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "media-gallery__item__icons",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 218,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        src: require('@tabler/icons/volume.svg'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 218,
          columnNumber: 56
        }
      })), /*#__PURE__*/React.createElement("span", {
        className: "media-gallery__file-extension__label",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 219,
          columnNumber: 11
        }
      }, ext));
    } else if (attachment.get('type') === 'video') {
      const ext = attachment.get('url').split('.').pop().toUpperCase();
      thumbnail = /*#__PURE__*/React.createElement("a", {
        className: classNames('media-gallery__item-thumbnail'),
        href: attachment.get('url'),
        onClick: this.handleClick,
        target: "_blank",
        alt: attachment.get('description'),
        title: attachment.get('description'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 225,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("video", {
        muted: true,
        loop: true,
        onMouseOver: this.handleVideoHover,
        onMouseOut: this.handleVideoLeave,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 233,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement("source", {
        src: attachment.get('url'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 239,
          columnNumber: 13
        }
      })), /*#__PURE__*/React.createElement("span", {
        className: "media-gallery__file-extension__label",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 241,
          columnNumber: 11
        }
      }, ext));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('media-gallery__item', `media-gallery__item--${attachment.get('type')}`, {
        standalone
      }),
      key: attachment.get('id'),
      style: {
        position,
        float,
        left,
        top,
        right,
        bottom,
        height,
        width: `${width}%`
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 247,
        columnNumber: 7
      }
    }, last && total > ATTACHMENT_LIMIT && /*#__PURE__*/React.createElement("div", {
      className: "media-gallery__item-overflow",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 249,
        columnNumber: 11
      }
    }, "+", total - ATTACHMENT_LIMIT + 1), /*#__PURE__*/React.createElement(Blurhash, {
      hash: attachment.get('blurhash'),
      className: classNames('media-gallery__preview', {
        'media-gallery__preview--hidden': visible && this.state.loaded
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 253,
        columnNumber: 9
      }
    }), visible && thumbnail);
  }
}, _defineProperty(_Item, "propTypes", {
  attachment: ImmutablePropTypes.record.isRequired,
  standalone: PropTypes.bool,
  index: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  displayWidth: PropTypes.number,
  visible: PropTypes.bool.isRequired,
  dimensions: PropTypes.object,
  autoPlayGif: PropTypes.bool,
  last: PropTypes.bool,
  total: PropTypes.number
}), _defineProperty(_Item, "defaultProps", {
  standalone: false,
  index: 0,
  size: 1
}), _Item)) || _class);
const mapStateToMediaGalleryProps = state => ({
  displayMedia: getSettings(state).get('displayMedia')
});
let MediaGallery = (_dec2 = connect(mapStateToMediaGalleryProps), _dec2(_class2 = injectIntl(_class2 = (_MediaGallery = class MediaGallery extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      visible: this.props.visible !== undefined ? this.props.visible : this.props.displayMedia !== 'hide_all' && !this.props.sensitive || this.props.displayMedia === 'show_all',
      width: this.props.defaultWidth
    });
    _defineProperty(this, "handleOpen", e => {
      e.stopPropagation();
      if (this.props.onToggleVisibility) {
        this.props.onToggleVisibility();
      } else {
        this.setState({
          visible: !this.state.visible
        });
      }
    });
    _defineProperty(this, "handleClick", index => {
      this.props.onOpenMedia(this.props.media, index);
    });
    _defineProperty(this, "handleRef", node => {
      if (node) {
        // offsetWidth triggers a layout, so only calculate when we need to
        if (this.props.cacheWidth) this.props.cacheWidth(node.offsetWidth);
        this.setState({
          width: node.offsetWidth
        });
      }
    });
    _defineProperty(this, "getSizeDataSingle", () => {
      const {
        media,
        defaultWidth
      } = this.props;
      const width = this.state.width || defaultWidth;
      const aspectRatio = media.getIn([0, 'meta', 'original', 'aspect']);
      const getHeight = () => {
        if (!aspectRatio) return width * 9 / 16;
        if (isPanoramic(aspectRatio)) return Math.floor(width / maximumAspectRatio);
        if (isPortrait(aspectRatio)) return Math.floor(width / minimumAspectRatio);
        return Math.floor(width / aspectRatio);
      };
      return ImmutableMap({
        style: {
          height: getHeight()
        },
        itemsDimensions: [],
        size: 1,
        width
      });
    });
    _defineProperty(this, "getSizeDataMultiple", size => {
      const {
        media,
        defaultWidth
      } = this.props;
      const width = this.state.width || defaultWidth;
      const panoSize = Math.floor(width / maximumAspectRatio);
      const panoSize_px = `${Math.floor(width / maximumAspectRatio)}px`;
      const style = {};
      let itemsDimensions = [];
      const ratios = Array(size).fill().map((_, i) => media.getIn([i, 'meta', 'original', 'aspect']));
      const [ar1, ar2, ar3, ar4] = ratios;
      if (size === 2) {
        if (isPortrait(ar1) && isPortrait(ar2)) {
          style.height = width - width / maximumAspectRatio;
        } else if (isPanoramic(ar1) && isPanoramic(ar2)) {
          style.height = panoSize * 2;
        } else if (isPanoramic(ar1) && isPortrait(ar2) || isPortrait(ar1) && isPanoramic(ar2) || isPanoramic(ar1) && isNonConformingRatio(ar2) || isNonConformingRatio(ar1) && isPanoramic(ar2)) {
          style.height = width * 0.6 + width / maximumAspectRatio;
        } else {
          style.height = width / 2;
        }

        //

        if (isPortrait(ar1) && isPortrait(ar2)) {
          itemsDimensions = [{
            w: 50,
            h: '100%',
            r: '2px'
          }, {
            w: 50,
            h: '100%',
            l: '2px'
          }];
        } else if (isPanoramic(ar1) && isPanoramic(ar2)) {
          itemsDimensions = [{
            w: 100,
            h: panoSize_px,
            b: '2px'
          }, {
            w: 100,
            h: panoSize_px,
            t: '2px'
          }];
        } else if (isPanoramic(ar1) && isPortrait(ar2) || isPanoramic(ar1) && isNonConformingRatio(ar2)) {
          itemsDimensions = [{
            w: 100,
            h: `${width / maximumAspectRatio}px`,
            b: '2px'
          }, {
            w: 100,
            h: `${width * 0.6}px`,
            t: '2px'
          }];
        } else if (isPortrait(ar1) && isPanoramic(ar2) || isNonConformingRatio(ar1) && isPanoramic(ar2)) {
          itemsDimensions = [{
            w: 100,
            h: `${width * 0.6}px`,
            b: '2px'
          }, {
            w: 100,
            h: `${width / maximumAspectRatio}px`,
            t: '2px'
          }];
        } else {
          itemsDimensions = [{
            w: 50,
            h: '100%',
            r: '2px'
          }, {
            w: 50,
            h: '100%',
            l: '2px'
          }];
        }
      } else if (size === 3) {
        if (isPanoramic(ar1) && isPanoramic(ar2) && isPanoramic(ar3)) {
          style.height = panoSize * 3;
        } else if (isPortrait(ar1) && isPortrait(ar2) && isPortrait(ar3)) {
          style.height = Math.floor(width / minimumAspectRatio);
        } else {
          style.height = width;
        }

        //

        if (isPanoramic(ar1) && isNonConformingRatio(ar2) && isNonConformingRatio(ar3)) {
          itemsDimensions = [{
            w: 100,
            h: '50%',
            b: '2px'
          }, {
            w: 50,
            h: '50%',
            t: '2px',
            r: '2px'
          }, {
            w: 50,
            h: '50%',
            t: '2px',
            l: '2px'
          }];
        } else if (isPanoramic(ar1) && isPanoramic(ar2) && isPanoramic(ar3)) {
          itemsDimensions = [{
            w: 100,
            h: panoSize_px,
            b: '4px'
          }, {
            w: 100,
            h: panoSize_px
          }, {
            w: 100,
            h: panoSize_px,
            t: '4px'
          }];
        } else if (isPortrait(ar1) && isNonConformingRatio(ar2) && isNonConformingRatio(ar3)) {
          itemsDimensions = [{
            w: 50,
            h: '100%',
            r: '2px'
          }, {
            w: 50,
            h: '50%',
            b: '2px',
            l: '2px'
          }, {
            w: 50,
            h: '50%',
            t: '2px',
            l: '2px'
          }];
        } else if (isNonConformingRatio(ar1) && isNonConformingRatio(ar2) && isPortrait(ar3)) {
          itemsDimensions = [{
            w: 50,
            h: '50%',
            b: '2px',
            r: '2px'
          }, {
            w: 50,
            h: '50%',
            l: '-2px',
            b: '-2px',
            pos: 'absolute',
            float: 'none'
          }, {
            w: 50,
            h: '100%',
            r: '-2px',
            t: '0px',
            b: '0px',
            pos: 'absolute',
            float: 'none'
          }];
        } else if (isNonConformingRatio(ar1) && isPortrait(ar2) && isNonConformingRatio(ar3) || isPortrait(ar1) && isPortrait(ar2) && isPortrait(ar3)) {
          itemsDimensions = [{
            w: 50,
            h: '50%',
            b: '2px',
            r: '2px'
          }, {
            w: 50,
            h: '100%',
            l: '2px',
            float: 'right'
          }, {
            w: 50,
            h: '50%',
            t: '2px',
            r: '2px'
          }];
        } else if (isPanoramic(ar1) && isPanoramic(ar2) && isNonConformingRatio(ar3) || isPanoramic(ar1) && isPanoramic(ar2) && isPortrait(ar3)) {
          itemsDimensions = [{
            w: 50,
            h: panoSize_px,
            b: '2px',
            r: '2px'
          }, {
            w: 50,
            h: panoSize_px,
            b: '2px',
            l: '2px'
          }, {
            w: 100,
            h: `${width - panoSize}px`,
            t: '2px'
          }];
        } else if (isNonConformingRatio(ar1) && isPanoramic(ar2) && isPanoramic(ar3) || isPortrait(ar1) && isPanoramic(ar2) && isPanoramic(ar3)) {
          itemsDimensions = [{
            w: 100,
            h: `${width - panoSize}px`,
            b: '2px'
          }, {
            w: 50,
            h: panoSize_px,
            t: '2px',
            r: '2px'
          }, {
            w: 50,
            h: panoSize_px,
            t: '2px',
            l: '2px'
          }];
        } else {
          itemsDimensions = [{
            w: 50,
            h: '50%',
            b: '2px',
            r: '2px'
          }, {
            w: 50,
            h: '50%',
            b: '2px',
            l: '2px'
          }, {
            w: 100,
            h: '50%',
            t: '2px'
          }];
        }
      } else if (size >= 4) {
        if (isPortrait(ar1) && isPortrait(ar2) && isPortrait(ar3) && isPortrait(ar4) || isPortrait(ar1) && isPortrait(ar2) && isPortrait(ar3) && isNonConformingRatio(ar4) || isPortrait(ar1) && isPortrait(ar2) && isNonConformingRatio(ar3) && isPortrait(ar4) || isPortrait(ar1) && isNonConformingRatio(ar2) && isPortrait(ar3) && isPortrait(ar4) || isNonConformingRatio(ar1) && isPortrait(ar2) && isPortrait(ar3) && isPortrait(ar4)) {
          style.height = Math.floor(width / minimumAspectRatio);
        } else if (isPanoramic(ar1) && isPanoramic(ar2) && isPanoramic(ar3) && isPanoramic(ar4)) {
          style.height = panoSize * 2;
        } else if (isPanoramic(ar1) && isPanoramic(ar2) && isNonConformingRatio(ar3) && isNonConformingRatio(ar4) || isNonConformingRatio(ar1) && isNonConformingRatio(ar2) && isPanoramic(ar3) && isPanoramic(ar4)) {
          style.height = panoSize + width / 2;
        } else {
          style.height = width;
        }

        //

        if (isPanoramic(ar1) && isPanoramic(ar2) && isNonConformingRatio(ar3) && isNonConformingRatio(ar4)) {
          itemsDimensions = [{
            w: 50,
            h: panoSize_px,
            b: '2px',
            r: '2px'
          }, {
            w: 50,
            h: panoSize_px,
            b: '2px',
            l: '2px'
          }, {
            w: 50,
            h: `${width / 2}px`,
            t: '2px',
            r: '2px'
          }, {
            w: 50,
            h: `${width / 2}px`,
            t: '2px',
            l: '2px'
          }];
        } else if (isNonConformingRatio(ar1) && isNonConformingRatio(ar2) && isPanoramic(ar3) && isPanoramic(ar4)) {
          itemsDimensions = [{
            w: 50,
            h: `${width / 2}px`,
            b: '2px',
            r: '2px'
          }, {
            w: 50,
            h: `${width / 2}px`,
            b: '2px',
            l: '2px'
          }, {
            w: 50,
            h: panoSize_px,
            t: '2px',
            r: '2px'
          }, {
            w: 50,
            h: panoSize_px,
            t: '2px',
            l: '2px'
          }];
        } else if (isPortrait(ar1) && isNonConformingRatio(ar2) && isNonConformingRatio(ar3) && isNonConformingRatio(ar4) || isPortrait(ar1) && isPanoramic(ar2) && isPanoramic(ar3) && isPanoramic(ar4)) {
          itemsDimensions = [{
            w: 67,
            h: '100%',
            r: '2px'
          }, {
            w: 33,
            h: '33%',
            b: '4px',
            l: '2px'
          }, {
            w: 33,
            h: '33%',
            l: '2px'
          }, {
            w: 33,
            h: '33%',
            t: '4px',
            l: '2px'
          }];
        } else {
          itemsDimensions = [{
            w: 50,
            h: '50%',
            b: '2px',
            r: '2px'
          }, {
            w: 50,
            h: '50%',
            b: '2px',
            l: '2px'
          }, {
            w: 50,
            h: '50%',
            t: '2px',
            r: '2px'
          }, {
            w: 50,
            h: '50%',
            t: '2px',
            l: '2px'
          }];
        }
      }
      return ImmutableMap({
        style,
        itemsDimensions,
        size: size,
        width
      });
    });
    _defineProperty(this, "getSizeData", size => {
      const {
        height,
        defaultWidth
      } = this.props;
      const width = this.state.width || defaultWidth;
      if (width) {
        if (size === 1) return this.getSizeDataSingle();
        if (size > 1) return this.getSizeDataMultiple(size);
      }

      // Default
      return ImmutableMap({
        style: {
          height
        },
        itemsDimensions: [],
        size,
        width
      });
    });
  }
  componentDidUpdate(prevProps) {
    const {
      media,
      visible,
      sensitive
    } = this.props;
    if (!is(media, prevProps.media) && visible === undefined) {
      this.setState({
        visible: prevProps.displayMedia !== 'hide_all' && !sensitive || prevProps.displayMedia === 'show_all'
      });
    } else if (!is(visible, prevProps.visible) && visible !== undefined) {
      this.setState({
        visible
      });
    }
  }
  render() {
    const {
      media,
      intl,
      sensitive,
      compact
    } = this.props;
    const {
      visible
    } = this.state;
    const sizeData = this.getSizeData(media.size);
    const children = media.take(ATTACHMENT_LIMIT).map((attachment, i) => /*#__PURE__*/React.createElement(Item, {
      key: attachment.get('id'),
      onClick: this.handleClick,
      attachment: attachment,
      index: i,
      size: sizeData.get('size'),
      displayWidth: sizeData.get('width'),
      visible: visible,
      dimensions: sizeData.get('itemsDimensions')[i],
      last: i === ATTACHMENT_LIMIT - 1,
      total: media.size,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 576,
        columnNumber: 7
      }
    }));
    let warning;
    if (sensitive) {
      warning = /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "status.sensitive_warning",
        defaultMessage: "Sensitive content",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 593,
          columnNumber: 17
        }
      });
    } else {
      warning = /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "status.media_hidden",
        defaultMessage: "Media hidden",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 595,
          columnNumber: 17
        }
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('media-gallery', {
        'media-gallery--compact': compact
      }),
      style: sizeData.get('style'),
      ref: this.handleRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 599,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames('spoiler-button', {
        'spoiler-button--minified': visible || compact
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 600,
        columnNumber: 9
      }
    }, visible || compact ? /*#__PURE__*/React.createElement(Button, {
      text: intl.formatMessage(messages.toggle_visible),
      icon: visible ? require('@tabler/icons/eye-off.svg') : require('@tabler/icons/eye.svg'),
      onClick: this.handleOpen,
      theme: "transparent",
      size: "sm",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 603,
        columnNumber: 15
      }
    }) : /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: this.handleOpen,
      className: "bg-transparent w-full h-full border-0",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 611,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-4 rounded-xl shadow-xl backdrop-blur-sm bg-white/75 dark:bg-slate-800/75 text-center inline-block space-y-4 max-w-[280px]",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 612,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "space-y-1",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 613,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "semibold",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 614,
        columnNumber: 21
      }
    }, warning), sensitive && /*#__PURE__*/React.createElement(Text, {
      size: "sm",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 617,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "status.sensitive_warning.subtitle",
      defaultMessage: "This content may not be suitable for all audiences.",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 618,
        columnNumber: 27
      }
    }))), /*#__PURE__*/React.createElement(Button, {
      type: "button",
      theme: "primary",
      size: "sm",
      icon: require('@tabler/icons/eye.svg'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 623,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "status.sensitive_warning.action",
      defaultMessage: "Show content",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 624,
        columnNumber: 21
      }
    }))))), children);
  }
}, _defineProperty(_MediaGallery, "propTypes", {
  sensitive: PropTypes.bool,
  standalone: PropTypes.bool,
  media: ImmutablePropTypes.list.isRequired,
  size: PropTypes.object,
  height: PropTypes.number.isRequired,
  onOpenMedia: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  defaultWidth: PropTypes.number,
  cacheWidth: PropTypes.func,
  visible: PropTypes.bool,
  onToggleVisibility: PropTypes.func,
  displayMedia: PropTypes.string,
  compact: PropTypes.bool
}), _defineProperty(_MediaGallery, "defaultProps", {
  standalone: false
}), _MediaGallery)) || _class2) || _class2);
export { MediaGallery as default };